export default __webpack_public_path__ + "static/media/collapse_charcoal.0afc5a35.svg";